Ext.ns('mx.data');

mx.data.MapProvider = mx.data.Record.create(
    [{name: 'id', type: 'string'}, {name: 'name', type: 'string'}],
    MXAT.API('maps/mapproviders/')
);

mx.data.MapProvider.prototype.toString = function() {
    return this.get('name');
};

new mx.data.Store({
    storeId: 'allmapproviders',
    url: MXAT.coreAPI('maps/allmapproviders/?mapDataAvailable=false'),
    record: mx.data.MapProvider,
    //    appendable: true
});
